export default __webpack_public_path__ + "images/Tapclicks.a1023adb7c1fa122a54e3b5b13d40160.svg";